<style src="vue-select/dist/vue-select.css"></style>
<style>
	.table-hover {
		width: 100%;
		table-layout: fixed;
	}

	.table-sm {
        font-size: 14px;
    }
</style>

<template>
	<section class="content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<div class="card">
						<div class="card-header">
							<h3 class="card-title">Daftar Kode Akun</h3>
							<div class="card-tools">
								<button type="button" class="btn btn-sm btn-primary" @click="newModal">
									<i class="fa fa-plus-square"></i>
									Tambah
								</button>
							</div>
						</div>
						<!-- /.card-header -->
						<div class="card-body table-responsive p-2">
							<table class="table table-hover table-sm">
								<thead style="color: black;">
									<tr>
										<th>KODE AKUN</th>
										<th style="width: 40%;">NAMA AKUN</th>
										<th>POST SALDO</th>
										<th>POST LAPORAN</th>
										<th>AKSI</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(row, index) in dataset.data" :key="row.id">
										<td>{{ row.id }}</td>
										<td>{{ row.nama_akun }}</td>
										<td>{{ formattedPostSaldo(row.post_saldo) }}</td>
										<td>{{ formattedPostLaporan(row.post_laporan) }}</td>
										<td>
											<button @click="editModal(row)" class="btn btn-xs btn-primary">
												<i class="fa fa-edit"></i>
											</button>
											<button @click="deleteData(row.id)" class="btn btn-xs btn-danger">
												<i class="fa fa-trash"></i>
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<!-- /.card-body -->
						<div class="card-footer">
							<pagination :data="dataset" @pagination-change-page="getResults"></pagination>
						</div>
					</div>
					<!-- /.card -->
				</div>
			</div>

			<!-- Modal -->
			<div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" v-show="!editmode">Tambah Kode Akun</h5>
							<h5 class="modal-title" v-show="editmode">Edit Kode Akun</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>

						<form @submit.prevent="editmode ? updateData() : createData()">
							<div class="modal-body">
								<div class="form-group">
									<label>Kode Akun</label>
									<input v-model="form.id" type="number" name="id" class="form-control"
										:class="{ 'is-invalid': form.errors.has('id') }" 
										:disabled="editmode" required>
									<has-error :form="form" field="id"></has-error>
								</div>

								<div class="form-group">
									<label>Nama Akun</label>
									<input v-model="form.nama_akun" type="text" name="nama_akun" class="form-control"
										:class="{ 'is-invalid': form.errors.has('nama_akun') }" required>
									<has-error :form="form" field="nama_akun"></has-error>
								</div>
								<div class="form-group">
									<label>Post Saldo</label>
									<select v-model="form.post_saldo" type="text" name="post_saldo" class="form-control"
										:class="{ 'is-invalid': form.errors.has('post_saldo') }" required>
										<option selected disabled value="">Pilih...</option>
										<option v-bind:value="1">Debet</option>
										<option v-bind:value="2">Credit</option>
									</select>
									<has-error :form="form" field="post_saldo"></has-error>
								</div>
								<div class="form-group">
									<label>Post Laporan</label>
									<select v-model="form.post_laporan" type="text" name="post_laporan" class="form-control"
										:class="{ 'is-invalid': form.errors.has('post_laporan') }" required>
										<option selected disabled value="">Pilih...</option>
										<option v-bind:value="1">Neraca</option>
										<option v-bind:value="2">Laba Rugi</option>
									</select>
									<has-error :form="form" field="post_laporan"></has-error>
								</div>
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
								<button v-show="editmode" type="submit" class="btn btn-success">Edit!</button>
								<button v-show="!editmode" type="submit" class="btn btn-primary">Tambah!</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		data() {
			return {
				editmode: false,
				dataset: {},
				form: new Form({
					id: '',
					nama_akun: '',
					post_saldo: '',
					post_laporan: '',
				})
			}
		},

		computed: {
            formattedPostSaldo() {
                return (value) => {
                    if (value === 1) return 'Debet';
                    if (value === 2) return 'Credit';
                    return '-';
                };
            },

			formattedPostLaporan() {
                return (value) => {
                    if (value == 1) return 'Neraca';
					if (value == 2) return 'Laba Rugi';
                    return '-';
                };
            }
        },

		methods: {
			async getResults(page = 1) {
				try {
					this.$Progress.start();
					const { data } = await axios.get(`api/akun?page=${page}`);
					this.dataset = data.data;
					this.$Progress.finish();
				} catch (error) {
					console.error("Error fetching data:", error);
					this.$Progress.fail();
				}
			},

			async loadData() {
				try {
					const { data } = await axios.get("api/akun");
					this.dataset = data.data;
				} catch (error) {
					console.error("Error loading data:", error);
				}
			},

			editModal(rowEdit) {
				this.editmode = true;
				this.form.reset();
				$('#addNew').modal('show');
				this.form.fill(rowEdit);
			},

			newModal() {
				this.editmode = false;
				this.form.reset();
				$('#addNew').modal('show');
			},

			async createData() {
				try {
					this.$Progress.start();
					const response = await axios.post("api/akun", this.form);
					if (response.data.success) {
						$('#addNew').modal('hide');
						Swal.fire("Berhasil!", response.data.message, "success");
						this.loadData();
					} else {
						Swal.fire("Gagal!", "Terjadi kesalahan, coba lagi.", "error");
					}
					this.$Progress.finish();
				} catch (error) {
					Swal.fire("Error!", "Terjadi kesalahan, coba lagi.", "error");
					this.$Progress.fail();
				}
			},

			async updateData() {
				try {
					this.$Progress.start();
					const response = await axios.put(`api/akun/${this.form.id}`, this.form);
					$('#addNew').modal('hide');
					Swal.fire("Berhasil!", response.data.message, "success");
					this.loadData();
					this.$Progress.finish();
				} catch (error) {
					Swal.fire("Gagal!", "Terjadi kesalahan saat update.", "error");
					this.$Progress.fail();
				}
			},

			async deleteData(id) {
				const result = await Swal.fire({
					title: "Hapus?",
					text: "Yakin untuk Menghapus Kode Akun?",
					showCancelButton: true,
					confirmButtonColor: "#d33",
					cancelButtonColor: "#3085d6",
					confirmButtonText: "Ya, Hapus!",
				});

				if (result.isConfirmed) {
					try {
						await axios.delete(`api/akun/${id}`);
						Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
						this.loadData();
					} catch (error) {
						Swal.fire("Gagal!", "Data tidak bisa dihapus.", "error");
					}
				}
			},
		},

		mounted() {
			this.loadData();
		},

		created() {
			this.$Progress.start();
			this.loadData();
			this.$Progress.finish();
		}
	}
</script>